import { useApiQuery } from '../useApiQuery';
import { taskKeys } from '@/lib/queryKeys';
import { taskEndpoints } from '@/lib/api/endpoints';
import { apiGet, operationsClient } from '@/lib/api';
import type { TaskListParams, TaskStatusGroupCounts } from '@/types/task';

/** Per-status task counts under the same non-status filters as the list. */
export function useTaskStatusCounts(
  params: Omit<TaskListParams, 'page' | 'limit' | 'status' | 'sortBy' | 'sortOrder'> = {},
  options?: { enabled?: boolean },
) {
  return useApiQuery<TaskStatusGroupCounts>({
    queryKey: taskKeys.counts(params),
    enabled: options?.enabled ?? true,
    // Badges are secondary: the tabs still filter without them, so a failed
    // count should not toast over the list.
    showErrorToast: false,
    queryFn: () =>
      apiGet<TaskStatusGroupCounts>(operationsClient, taskEndpoints.counts(), { params }),
  });
}
